import { useQuery } from '@tanstack/react-query';
import { api_host } from '../../../common/globals/constants';

export const useFetchEventsMeasurements = ({
  urlParams,
  fetchApi,
  enabled = true,
  refreshTime = false,
}) => {
  return useQuery({
    queryKey: ['eventsMeasurements', fetchApi, urlParams.toString()],
    queryFn: async () => {
      const url = `${api_host}/reporte/online/indicadores/${fetchApi}/?${urlParams.toString()}`;
      const response = await fetch(url);
      const data = await response.json();

      if (data.status === 1 || data.status === 5) {
        localStorage.setItem('isAuthenticated', false);
        throw new Error('Authentication failed');
      }

      return data;
    },
    enabled,
    gcTime: 0,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchInterval: refreshTime || false,
  });
};
